import {
  useGetOccupationIndustriesQuery,
  useGetOccupationPositionsQuery,
} from '@/store/api/services/resources/occupation';

interface Props {
  id: string;
}

export const OccupationIndustryName = ({ id }: Props) => {
  const { data } = useGetOccupationIndustriesQuery();
  const industry = data?.data?.find((i) => i.id === id);
  return <>{industry?.name?.en ?? '-'}</>;
};

export const OccupationPositionName = ({ id }: Props) => {
  const { data } = useGetOccupationPositionsQuery();
  const position = data?.data?.find((p) => p.id === id);
  return <>{position?.name?.en ?? '-'}</>;
};
